<div *ngIf="isUnavailableFlag()" class="alert alert-danger">
  <strong><i class="fas fa-stop-circle"></i> {{ flag.Message }}</strong>
</div>
<div *ngIf="isWarningFlag()" class="alert alert-warning">
  <strong><i class="fas fa-exclamation-circle"></i> {{ flag.Message }}</strong>
</div>
<div *ngIf="isInformationFlag()" class="alert alert-info">
  <strong><i class="fas fa-info-circle"></i> {{ flag.Message }}</strong>
</div>